import React from 'react';

const ChevronUp = () => (
  <svg
    version="1.1"
    id="icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="10px"
    height="6px"
    viewBox="0 0 10 6"
    style={{ enableBackground: 'new 0 0 10 6' }}
    xmlSpace="preserve"
  >
    <polygon points="5,0 10,5 9.3,5.7 5,1.4 0.7,5.7 0,5 " />
  </svg>
);

export default ChevronUp;
